import { Box, TextLink } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";

import React from "react";
import { StyleSheet } from "react-native";

export interface AdditionalLinkProps {
  link: viewjob.model.AdditionalLinksElementModel;
  includeSuffix: boolean;
  fromParameter?: string;
}

function sanitizeLabel(label: string, suffix: string): string {
  const capitalizedLabel = label
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(" ");

  return `${capitalizedLabel} ${suffix}`;
}

export const AdditionalLink: React.FC<AdditionalLinkProps> = ({
  link,
  includeSuffix,
  fromParameter,
}) => {
  const { pgettext } = useI18n();

  const label = includeSuffix
    ? sanitizeLabel(link.surfaceElementLabel, pgettext("AdditionalLink label suffix", "jobs"))
    : link.surfaceElementLabel;

  const url = fromParameter
    ? `${link.surfaceElementUrl}?from=${fromParameter}`
    : link.surfaceElementUrl;

  return (
    <Box sx={styles.container}>
      <TextLink targetUrl={url} level={2} variant="strong" sx={{ textDecorationLine: "none" }}>
        {label}
      </TextLink>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
});

export default AdditionalLink;
